/**
 * 创建人：D
 * 时间：2019-03-8
 * 描述：弹出框服务
 * 更新记录:
 */
import { Injectable } from '@angular/core';
import { SwMessageService } from '../components/basic-components/sw-message/sw-message.service';


/**
 * 提示框公共服务
 */
@Injectable({
  providedIn: 'root'
})
export class SwMassageBoxService {
 

  /**
   * @ignore
   */
  constructor(
    private swMessageService: SwMessageService,  //消息提示服务
  ) { }
   /**
   * 错误提示卡片（自动销毁）
   * @param title 提示类型
   */
  waringError(title:string){
    this.swMessageService.showAlert(title, 'we');
  }
  /**
   * 错误提示卡片（自动销毁）
   * @param title 提示类型
   */
  waring(title:string){
    this.swMessageService.showAlert(title, 'e');
  }

   /**
   * 成功提示框
   * @param title 提示类型
   */
  success(title:string){
    this.swMessageService.showAlert(title, 's');
  }

  /**
   * 消息提示框
   * @param title 提示类型
   */
  info(title:string){
    this.swMessageService.showAlert(title, 'i');
  }

  /**
   * 警告提示框
   * @param title 提示类型
   */
  danger(title:string){
    this.swMessageService.showAlert(title, 'w');
  }
  /**
   * 错误提示框,有确认按钮
   * @param title 提示类型
   */
  waringAlert(title:string,calback?:any){
    this.swMessageService.showModal(title, 'e',calback);
  }
  
  /**
   * 成功提示框,有确认按钮
   * @param title 提示类型
   */
  successAlert(title:string,calback?:any){
    this.swMessageService.showModal(title, 's',calback);
  }
  /**
   * 消息提示框,有确认按钮
   * @param title 提示类型
   */
  infoAlert(title:string,calback?:any){
    this.swMessageService.showModal(title, 'i',calback);
  }

  //警告提示框,有确认按钮
  dangerAlert(title:string,calback?:any){
    this.swMessageService.showModal(title, 'w',calback);
  }

}
